import React, {Component} from 'react';

class Class395 extends Component {
    render() {
        return (
            <div>
                <div className='main-text'>
                    <h1>British Rail Class 395</h1>
                    I think these trains are quite special. First of all, they are able to operate at over 140 MPH on overhead electric power on high speed lines, but can also do 100 MPH on the classic third-rail network. They have a blisteringly fast acceleration, are quite comfortable to ride and I think look stunning. However, sadly some seats do not have windows because of the space taken up for the sliding doors.
                    <p/>

                    <div className='embed-responsive embed-responsive-16by9'>
                        <iframe className='embed-responsive-item' src='https://www.youtube.com/embed/FNSHgCokLGo' allowFullScreen title='A YouTube video of a ride on a Class 395 from Stratford International to Ashford and then on to Canterbury'></iframe>
                    </div>
                </div>
            </div>
        );
    }
}

export default Class395;